import type { ManualState, ResetAfter } from './types';

/**
 * The API's `manualState` enum is the Postgres one (snake_case, `appear_*`);
 * the client vocabulary is camelCase. Mapping in one place means a typo is a
 * compile error, not a silently ignored presence change.
 */
export const TO_WIRE_MANUAL: Record<ManualState, string> = {
  appearAvailable: 'appear_available',
  appearBusy: 'appear_busy',
  appearDnd: 'appear_dnd',
  appearAway: 'appear_away',
  beRightBack: 'be_right_back',
  appearOffline: 'appear_offline',
};

/** The inverse, for hydrating the signed-in user's declaration from the API. */
export const FROM_WIRE_MANUAL: Readonly<Record<string, ManualState>> = {
  appear_available: 'appearAvailable',
  appear_busy: 'appearBusy',
  appear_dnd: 'appearDnd',
  appear_away: 'appearAway',
  be_right_back: 'beRightBack',
  appear_offline: 'appearOffline',
};

const HOUR = 60;

/** `PATCH /presence/me` takes minutes; `null` means "until I change it". */
export const RESET_AFTER_MINUTES: Record<ResetAfter, number | null> = {
  never: null,
  '30m': 30,
  '1h': HOUR,
  '2h': 2 * HOUR,
  '4h': 4 * HOUR,
  /* Rest of today / rest of the week, clamped to the API's 30-day ceiling. */
  today: 12 * HOUR,
  thisWeek: 7 * 24 * HOUR,
};
